"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcPoolOutGivenSingleIn = exports.calcInGivenOut = exports.calcOutGivenIn = exports.calcSpotPrice = exports.WeightedPoolMath = void 0;
const unit_1 = require("@keplr-wallet/unit");
const utils_1 = require("../utils");
exports.WeightedPoolMath = {
    calcSpotPrice,
    calcOutGivenIn,
    calcInGivenOut,
    calcPoolOutGivenSingleIn,
};
const oneDec = new unit_1.Dec(1);
function calcSpotPrice(tokenBalanceIn, tokenWeightIn, tokenBalanceOut, tokenWeightOut, swapFee) {
    const number = tokenBalanceIn.quo(tokenWeightIn);
    const denom = tokenBalanceOut.quo(tokenWeightOut);
    const scale = oneDec.quo(oneDec.sub(swapFee));
    return number.quo(denom).mul(scale);
}
exports.calcSpotPrice = calcSpotPrice;
function calcOutGivenIn(tokenBalanceIn, tokenWeightIn, tokenBalanceOut, tokenWeightOut, tokenAmountIn, swapFee) {
    const weightRatio = tokenWeightIn.quo(tokenWeightOut);
    let adjustedIn = oneDec.sub(swapFee);
    adjustedIn = tokenAmountIn.mul(adjustedIn);
    const y = tokenBalanceIn.quo(tokenBalanceIn.add(adjustedIn));
    const foo = (0, utils_1.pow)(y, weightRatio);
    const bar = oneDec.sub(foo);
    return tokenBalanceOut.mul(bar);
}
exports.calcOutGivenIn = calcOutGivenIn;
function calcInGivenOut(tokenBalanceIn, tokenWeightIn, tokenBalanceOut, tokenWeightOut, tokenAmountOut, swapFee) {
    const weightRatio = tokenWeightOut.quo(tokenWeightIn);
    const diff = tokenBalanceOut.sub(tokenAmountOut);
    const y = tokenBalanceOut.quo(diff);
    let foo = (0, utils_1.pow)(y, weightRatio);
    foo = foo.sub(oneDec);
    const tokenAmountIn = oneDec.sub(swapFee);
    return tokenBalanceIn.mul(foo).quo(tokenAmountIn);
}
exports.calcInGivenOut = calcInGivenOut;
function calcPoolOutGivenSingleIn(tokenBalanceIn, tokenWeightIn, poolSupply, totalWeight, tokenAmountIn, swapFee) {
    const normalizedWeight = tokenWeightIn.quo(totalWeight);
    const zaz = oneDec.sub(normalizedWeight).mul(swapFee);
    const tokenAmountInAfterFee = tokenAmountIn.mul(oneDec.sub(zaz));
    const newTokenBalanceIn = tokenBalanceIn.add(tokenAmountInAfterFee);
    const tokenInRatio = newTokenBalanceIn.quo(tokenBalanceIn);
    // uint newPoolSupply = (ratioTi ^ weightTi) * poolSupply;
    const poolRatio = (0, utils_1.pow)(tokenInRatio, normalizedWeight);
    const newPoolSupply = poolRatio.mul(poolSupply);
    return newPoolSupply.sub(poolSupply);
}
exports.calcPoolOutGivenSingleIn = calcPoolOutGivenSingleIn;
//# sourceMappingURL=weighted.js.map